import React from "react";

import {
  ActionGroup,
  BlueSpan,
  HeaderBanner,
  PBanner,
  SectionHeader,
  SectionRow,
  TableWrapper,
} from "pages/main/BannerManager/index.style";
import { ActionButton } from "shared/ui/buttons";
import { DataTable, Pagination, SelectAllToggle } from "shared/ui/table";

export default function BannerSection({
  actions = [],
  columns,
  count,
  pagination,
  selection,
  title,
}) {
  return (
    <>
      <SectionRow>
        <SectionHeader>
          <HeaderBanner>{title}</HeaderBanner>
          <PBanner>
            검색 결과 <BlueSpan>{count}건</BlueSpan> 검색되었습니다.
          </PBanner>
        </SectionHeader>
        <ActionGroup>
          <SelectAllToggle
            totalCount={pagination.totalCount}
            selectedCount={selection.count}
            allSelected={selection.isAllSelected}
            onToggle={() =>
              selection.isAllSelected ? selection.clear() : selection.selectAll()
            }
          />
          {actions.map((action) => (
            <ActionButton
              key={action.label}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.label}
            </ActionButton>
          ))}
        </ActionGroup>
      </SectionRow>
      <TableWrapper>
        <DataTable
          columns={columns}
          data={pagination.pageItems}
          selectable
          selection={selection}
        />
      </TableWrapper>
      <Pagination
        page={pagination.page}
        pageSize={pagination.pageSize}
        totalCount={pagination.totalCount}
        onPageChange={pagination.setPage}
      />
    </>
  );
}
